export default __webpack_public_path__ + "static/media/logo.d594a769.png";